module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.a-function.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.a-function.js
// module chunks = 0